var render = function render(){var _vm=this,_c=_vm._self._c;return (this.condition())?_c('v-container',[_c('span',[_vm._v(_vm._s(this.prefix)+" + "+_vm._s(this.displayText)+" "+_vm._s(this.suffix)+" ")]),(this.br)?_c('br'):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }